import LoyaltyProgram from '@components/LoyaltyProgram';
import { Picture, Modal } from '@ui';
import { useMemo, useState } from 'react';
import icons from '@icons';
import SubscribeProductMobile from '@components/SubscribeProductMobile';
import SubscribeProduct from '@components/SubscribeProduct';
import './index.scss';
import BuyButton from '@components/BuyButton';
import {
  ArchievedProduct,
  NotForSaleProduct,
  PromocodeGiftItem
} from '../components';
import { preparePriceFloatObject } from '@utils/floatNumbers';
import PromoRecipes from '../PromoRecipes';
import Measures from '@utils/measures';
import { MAX_CASHBACK_GOLD_STATUS_VALUE } from '@utils/cashback';
import { twcls } from '@utils/twcls';
import { observer } from 'mobx-react';
import { Link } from '@compat/router';

const {
  gift: { dark: giftDark }
} = icons.Fill;
const {
  chevronRight: { darkGrey: crDGOutlined }
} = icons.Outline;

const PPMobilePrice = ({
  canBeBought,
  breadCrumbsLastItem,
  changeUrlToUpBreadCrumbs,
  priceBlockWeightPrice,
  isPreorder,
  available,
  isProductNotForSale,
  id,
  oldPriceField2,
  specialPriceData,
  discounPriceField,
  price2,
  measureItem,
  measure_id,
  weight_of_goods,
  price,
  isVesovoi,
  oldPriceField,
  isProductArchieved,
  supplyDate,
  isDigital,
  amountInCart,
  multiPricePromo,
  promocodeGiftItems,
  isMenu,
  isWithouthMeasure = false
}) => {
  const [isShowCashbackModal, setIsShowCashbackModal] = useState(false);
  const [isSubscribeModalOpened, setIsSubscribeModalOpened] = useState(false);

  const cashbackModalStateHandler = () => {
    setIsShowCashbackModal(true);
  };

  const showObjFields = {
    leftTop: oldPriceField2,
    leftBottom: price2,
    rightTop: oldPriceField,
    rightBottom: price,
    leftWeight: weight_of_goods,
    rightWeight: measureItem?.weight,
    discount: discounPriceField
  };

  if (weight_of_goods > 1 && measure_id === 2) {
    showObjFields.leftTop = oldPriceField;
    showObjFields.leftBottom = price;
    showObjFields.rightTop = oldPriceField2;
    showObjFields.rightBottom = price2;
    showObjFields.leftWeight = !isVesovoi
      ? weight_of_goods
      : measureItem?.weight;
    showObjFields.rightWeight = weight_of_goods;
    showObjFields.discount = discounPriceField;
  }

  const uyAtOncePromo =
    multiPricePromo &&
    typeof multiPricePromo?.buy_at_once === 'number' &&
    multiPricePromo?.buy_at_once > 0 &&
    amountInCart < multiPricePromo?.buy_at_once;

  if (uyAtOncePromo) {
    showObjFields.leftBottom = preparePriceFloatObject(
      priceBlockWeightPrice
        ? multiPricePromo?.weightPriceData?.price1Kg
        : isVesovoi
        ? multiPricePromo?.weightPriceData?.price
        : multiPricePromo.price_active
    );
    showObjFields.rightBottom = preparePriceFloatObject(
      priceBlockWeightPrice
        ? multiPricePromo?.weightPriceData?.price
        : isVesovoi
        ? multiPricePromo?.weightPriceData?.price1Kg
        : multiPricePromo?.price_active
    );
    showObjFields.discount = Math.round(
      priceBlockWeightPrice
        ? 100 -
            (multiPricePromo?.weightPriceData?.price1Kg / price.wholePart) * 100
        : isVesovoi
        ? 100 -
          (multiPricePromo?.weightPriceData?.price / price2.wholePart) * 100
        : 100 - (multiPricePromo?.price_active / price) * 100
    );
  }

  const priceComp = useMemo(
    () => (
      <div className='pp-mobile-price__price-wrapper'>
        <div className='pp-mobile-price__price'>
          {specialPriceData ? (
            <div className='pp-mobile-price__discont-price'>
              {specialPriceData.price} ₽ от {specialPriceData.amount} шт
            </div>
          ) : (
            <div className='pp-mobile-price__discont-price'> </div>
          )}
        </div>

        <div className={'pp-mobile-price__price'}>
          <div className='pp-mobile-price__discont-price-main'>
            {price2?.wholePart}
            {price2?.floatPart && (
              <span className='pp-mobile-price__discont-price-main__decimal'>
                ,{price2?.floatPart}
              </span>
            )}
            <span className='pp-mobile-price__discont-price-main__ruble'>
              ₽/{weight_of_goods}&nbsp;
              {measureItem && measureItem.symbol}
            </span>
          </div>

          {oldPriceField2 && (
            <div className='pp-mobile-price__old-price-main'>
              {oldPriceField2}₽
            </div>
          )}
        </div>
      </div>
    ),
    [
      measureItem,
      oldPriceField2,
      price2?.floatPart,
      price2?.wholePart,
      specialPriceData,
      weight_of_goods
    ]
  );

  return (
    <div className='pp-mobile-price'>
      {isProductArchieved && (
        <ArchievedProduct
          breadCrumbsLastItem={breadCrumbsLastItem}
          changeUrlToUpBreadCrumbs={changeUrlToUpBreadCrumbs}
        />
      )}
      {isShowCashbackModal && (
        <Modal
          placementMobile='bottom-sheet'
          placementTablet='bottom-sheet'
          onClose={() => setIsShowCashbackModal(false)}
        >
          <div className='w-full pb-3 bg-white'>
            <LoyaltyProgram fullComponent />
            <div className='w-full px-3 pb-3'>
              <Link
                className='text-sm flex items-center justify-center bg-white border border-solid border-[var(--main-font-color)] p-3 rounded-lg w-full text-center'
                to='/loyalty-program'
              >
                Больше о программе лояльности
              </Link>
            </div>
          </div>
        </Modal>
      )}
      {isMenu && !location.pathname.includes('bar-menu') && !available && (
        <div className='pp-mobile-price__wrapper'>{priceComp}</div>
      )}
      {!isMenu && isProductNotForSale && !isProductArchieved && (
        <NotForSaleProduct />
      )}
      {(isMenu ? false : !available) &&
        !isProductNotForSale &&
        !isProductArchieved && (
          <div>
            <div className=''>
              <SubscribeProductMobile
                breadCrumbsLastItem={breadCrumbsLastItem}
                changeUrlToUpBreadCrumbs={changeUrlToUpBreadCrumbs}
                supplyDate={supplyDate}
                openModal={() => setIsSubscribeModalOpened(true)}
              />
              <Modal
                open={isSubscribeModalOpened}
                className='pop-subscribe'
                withoutCross
                onClose={() => {
                  setIsSubscribeModalOpened(false);
                }}
              >
                {close => (
                  <SubscribeProduct
                    productId={id}
                    isModal
                    centeredModal
                    closeModal={() => {
                      close();
                      setIsSubscribeModalOpened(false);
                    }}
                    subscriptionType='in_stock'
                  />
                )}
              </Modal>
            </div>
          </div>
        )}

      {available && (
        <>
          {!isMenu && (
            <div
              className='pp-mobile-price__cashback'
              onClick={cashbackModalStateHandler}
            >
              <Picture icon={giftDark} height='16' width={'16'} />
              Кэшбэк до {MAX_CASHBACK_GOLD_STATUS_VALUE}%
              <Picture
                icon={crDGOutlined}
                width='16'
                height='16'
                pictureClassName='pp-mobile-price__cashback__icon'
              />
            </div>
          )}
          <PromoRecipes productId={+id} isMobile />
          {!!promocodeGiftItems?.length && (
            <div className=''>
              <PromocodeGiftItem promocodeGiftItems={promocodeGiftItems} />
            </div>
          )}
          {!specialPriceData ? (
            <div
              className={twcls(
                'pp-mobile-price__wrapper',
                isMenu && 'pp-mobile-price__wrapper--bar-menu'
              )}
            >
              <div className='pp-mobile-price__price-wrapper'>
                {showObjFields?.leftTop && (
                  <div className='pp-mobile-price__price'>
                    <div className='pp-mobile-price__old-price-main'>
                      {[showObjFields?.leftTop]}₽
                    </div>
                    {showObjFields.discount && (
                      <div className='pp-mobile-price__discount-badge'>
                        -{showObjFields.discount}%
                      </div>
                    )}
                  </div>
                )}

                <div className={'pp-mobile-price__price'}>
                  <div className='pp-mobile-price__price-main'>
                    {showObjFields?.leftBottom?.wholePart}
                    {showObjFields?.leftBottom?.floatPart && (
                      <span className='pp-mobile-price__price-main__decimal'>
                        ,{showObjFields?.leftBottom?.floatPart}
                      </span>
                    )}
                    <span className='pp-mobile-price__price-main__ruble'>
                      ₽
                      {!isWithouthMeasure &&
                        `/${Measures.prepare({
                          measure: measureItem?.symbol,
                          weight: showObjFields?.leftWeight
                        })}`}
                    </span>
                  </div>
                </div>
              </div>

              {isVesovoi &&
                weight_of_goods > 0 &&
                weight_of_goods !== 1 &&
                measure_id === 2 && (
                  <div className='pp-mobile-price__price-wrapper'>
                    {showObjFields?.rightTop && (
                      <div className='pp-mobile-price__price'>
                        <div className='pp-mobile-price__old-price-secondary'>
                          {[showObjFields?.rightTop]}₽
                        </div>
                      </div>
                    )}

                    <div className={'pp-mobile-price__price'}>
                      <div className='pp-mobile-price__price-secondary'>
                        {showObjFields?.rightBottom?.wholePart}
                        {showObjFields?.rightBottom?.floatPart && (
                          <span className='pp-mobile-price__price-secondary__decimal'>
                            ,{showObjFields?.rightBottom?.floatPart}
                          </span>
                        )}
                        <span className='pp-mobile-price__price-secondary__ruble'>
                          ₽/{[showObjFields?.rightWeight]}&nbsp;
                          {measureItem && measureItem.symbol}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              {available && (
                <BuyButton
                  canBeBought={canBeBought}
                  available={available}
                  isPreorder={isPreorder}
                  className='product-page'
                  productId={id}
                  isDigital={isDigital}
                />
              )}
            </div>
          ) : (
            <>
              <div className='pp-mobile-price__wrapper'>
                {priceComp}
                <BuyButton
                  canBeBought={canBeBought}
                  available={available}
                  isPreorder={isPreorder}
                  className='product-page'
                  productId={id}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default observer(PPMobilePrice);
